import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";
import { Input, Table } from "@/components/erp/ui";

const Rate = ({ v }) => <span className={v >= 50 ? "text-emerald-700 font-semibold" : ""}>{v}%</span>;

const Steps = ({ steps }) => (
  <div className="flex flex-wrap gap-1.5">
    {steps.map((s) => (
      <div key={s.step} className={`text-[11px] rounded-md px-2 py-1 border ${s.label || s.by ? "border-slate-300 bg-white" : "border-dashed border-slate-200 text-slate-400"}`}>
        <div className="font-semibold">{s.step}</div>
        <div>{s.label || "—"}</div>
        {s.by && <div className="text-slate-500">oleh {s.by}</div>}
      </div>
    ))}
  </div>
);

// Rekap bulanan quotation & order per sumber, per orang, dan siapa yang menangani tiap step
export const SourceRecap = () => {
  const [month, setMonth] = useState(new Date(Date.now() + 7 * 3600000).toISOString().slice(0, 7));
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/quotations/source-recap", { params: { month } }).then(({ data }) => setD(data)).catch(() => setD({ channels: [], people: [], items: [] })); }, [month]);
  return (
    <div className="space-y-5" data-testid="source-recap">
      <div className="flex flex-wrap items-center gap-3">
        <div className="text-sm text-slate-600">{d?.best ? <>Kanal paling efektif bulan ini: <b data-testid="source-recap-best">{d.best}</b></> : "Belum ada order bulan ini."}</div>
        <div className="w-44 ml-auto"><Input type="month" data-testid="source-recap-month" value={month} onChange={(e) => setMonth(e.target.value)} /></div>
      </div>
      <div>
        <div className="font-semibold mb-2">Per Sumber</div>
        <Table testid="source-recap-channels" columns={["Sumber", "Quotation", "Jadi Order", "Konversi", "Nilai Order"]} rows={d?.channels || []} renderRow={(r) => (
          <tr key={r.type} className="border-t border-slate-100" data-testid={`source-ch-${r.type}`}>
            <td className="px-4 py-3">{r.label}</td><td className="px-4 py-3">{r.quote}</td>
            <td className="px-4 py-3 text-emerald-700">{r.order}</td><td className="px-4 py-3"><Rate v={r.rate} /></td>
            <td className="px-4 py-3">{formatIDR(r.order_value)}</td>
          </tr>
        )} />
      </div>
      <div>
        <div className="font-semibold mb-2">Per Orang (sumber tercatat)</div>
        <Table testid="source-recap-people" columns={["Nama", "Sumber", "Quotation", "Jadi Order", "Konversi", "Nilai Order"]} rows={d?.people || []} renderRow={(r) => (
          <tr key={r.type + r.email} className="border-t border-slate-100" data-testid={`source-person-${r.email}`}>
            <td className="px-4 py-3">{r.name}</td><td className="px-4 py-3">{r.label}</td><td className="px-4 py-3">{r.quote}</td>
            <td className="px-4 py-3 text-emerald-700">{r.order}</td><td className="px-4 py-3"><Rate v={r.rate} /></td><td className="px-4 py-3">{formatIDR(r.value)}</td>
          </tr>
        )} />
      </div>
      <div>
        <div className="font-semibold mb-2">Alur & Penanggung Jawab per Quotation</div>
        <div className="space-y-2" data-testid="source-recap-items">
          {(d?.items || []).length === 0 && <div className="text-sm text-slate-400">Tidak ada quotation.</div>}
          {(d?.items || []).map((q) => (
            <div key={q.id} className="border border-slate-200 rounded-xl p-3" data-testid={`source-item-${q.code}`}>
              <div className="flex flex-wrap items-center gap-2 mb-2 text-sm">
                <b>{q.code}</b><span className="text-slate-500">{q.customer_name}</span>
                <span className="text-xs text-slate-400">{(q.created_at || "").slice(0, 10)}</span>
                <span className={`ml-auto text-xs px-2 py-0.5 rounded-full ${q.order ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-600"}`}>{q.order ? "Jadi Order" : q.status}</span>
              </div>
              <Steps steps={q.steps} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
